module.exports = __webpack_public_path__ + "img/facebook.4e1a935.png";